import { StyleForText } from "./TextButton.presents"
import { PropsType } from "./TextButton.props"

export const TextButton = (props: PropsType) => {
  return <StyleForText {...props}>{props.text}</StyleForText>
}